module.exports = __webpack_public_path__ + "static/media/noun_book_5021.e9d0469d.svg";